import { formatDate } from 'src/utils/formatDate';
import {
  QuestionTemplateGetAttributes,
  Question,
  Option,
} from 'src/models/QuestionTemplateModel';
export interface QuestionCategoryContainQuestionTemplatesAttributes {
  category_id: string;
  category_name: string;
  category_icon: string;
  question_templates: QuestionTemplateGetAttributes[];
}
export interface AnswerPerQuestionCategory {
  category_id: string;
  category_name: string;
  category_icon: string;
  questions: Question[];
}
export interface AnswerSendAttributes {
  answer: AnswerPerQuestionCategory[];
}
export interface AnswerGetAttributes {
  id: string;
  answer: AnswerPerQuestionCategory[];
  created_at: string;
  updated_at: string;
}
export class AnswerModel {
  id: string;
  answer: AnswerPerQuestionCategory[];
  created_at: string;
  updated_at: string;

  constructor(
    input: AnswerGetAttributes | null,
    question_categories: QuestionCategoryContainQuestionTemplatesAttributes[]
  ) {
    this.id = input ? input.id : '';
    this.answer = input ? input.answer : this.getAnswer(question_categories);
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getAnswer(
    question_categories: QuestionCategoryContainQuestionTemplatesAttributes[]
  ): AnswerPerQuestionCategory[] {
    return question_categories.map((question_category) => {
      return {
        category_id: question_category.category_id,
        category_name: question_category.category_name,
        category_icon: question_category.category_icon,
        questions: question_category.question_templates.map(
          (question_template: QuestionTemplateGetAttributes) => {
            const question = question_template.question;
            if (question.type == 'radio') {
              question.options.map((option) => {
                if (option.questions) {
                  option.questions = option.questions.map((childQuestion) => {
                    return { ...childQuestion, answer: null };
                  });
                }
                return option;
              });
            }
            return { ...question, answer: null };
          }
        ),
      };
    });
  }
  getSendAttributes(): AnswerSendAttributes {
    return {
      answer: this.answer.map((question_category) => {
        question_category.questions = question_category.questions.map(
          (question) => {
            // 回答があってラジオタイプの場合
            if (question.answer && question.type == 'radio') {
              question.options = question.options.map((option) => {
                const newOption = option;
                if (
                  option.value !== question.answer?.value &&
                  option.questions
                ) {
                  // 回答以外のオプションの下の回答はすべてnullにする
                  newOption.questions = option.questions.map((question) => {
                    question.answer = null;
                    return question;
                  });
                }
                return newOption;
              });
            }
            return question;
          }
        );
        return question_category;
      }),
    };
  }
}
export type AnswerCollection = AnswerModel[];
